import CheckpointHeader from "../components/createJobcard/stage/CheckpointItem/CheckpointHeader";
import FifthCheckPointItem from "../components/createJobcard/stage/fifthStep/FifthCheckPointItem";

export const stepConfigs = {
  1: {
    useVisibility: true,
  },
  2: {
    renderCheckpointOverride: ({ checkpoint, cylinder }) => {
      if (cylinder.actualWeight && checkpoint.id === 13) {
        return (
          <div className="bg-white rounded-xl p-4 py-2 shadow-sm border-1">
            <CheckpointHeader
              name={checkpoint.name}
              description={checkpoint.description}
            />
            <p className="text-blue-50 py-3">{cylinder.actualWeight} kg</p>
          </div>
        );
      }
      return null;
    },
  },

  6: {
    actionHidden: ({ stageUpdates }) => {
      const hydro = stageUpdates
        .find((s) => s.stageId === 2)
        ?.checkpointUpdates.find((cp) => cp.checkpointId === 12);
      const isHydroNotRequired = hydro?.resultVal?.toLowerCase() === "no";
      
      return {
        hideOn: isHydroNotRequired,
        msg: "Hydro testing performed is not required!",
      };
    },
    discardConditions: [
      {
        id: 22,
        discardOn: "not ok",
        message:
          "Cylinder will be discarded if hydro testing performance is not ok.",
      },
    ],
  },
  4: {
    useVisibility: true,
  },
  5: {
    CheckpointComponent: FifthCheckPointItem,
  },
  7: {
    useVisibility: true,
    visibilitySource: (stageUpdates) =>
      stageUpdates.find((s) => s.stageId === 1)?.checkpointUpdates,
    discardConditions: [
      {
        id: 25,
        discardOn: "thread_rejected",
        message: "Cylinder will be discarded if Thread Rejected.",
      },
    ],
  },
};
